import { render } from "./PastProjects.vue?vue&type=template&id=4b88e270&scoped=true"
const script = {}

import "./PastProjects.vue?vue&type=style&index=0&id=4b88e270&scoped=true&lang=scss"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b88e270"]])

export default __exports__